var _style, _rect, _polyline, _polyline2, _line, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokeAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.2,
    className: "st0",
    width: 15,
    height: 7.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "2,10.3 5.2,6.7 8.8,10.3 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.2,10.3 5.3,8.1 7.5,10.3 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.1,
    y1: 10.4,
    x2: 11.1,
    y2: 8.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 10.4,
    x2: 13,
    y2: 8.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,8.6c0-1.1-0.9-2-2-2s-2,0.9-2,2H14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeAlarm);
export default __webpack_public_path__ + "static/media/SmokeAlarm.33921af93f594e7c0d317fb09f33ae91.svg";
export { ForwardRef as ReactComponent };